import {
  BoxGeometry,
  CylinderGeometry,
  Group,
  Mesh,
  MeshStandardMaterial,
  SphereGeometry
} from 'three';

/** Jax mesh — staff + lamppost silhouette (OCP registry). */
export function createJaxMesh(team = 'blue') {
  const group = new Group();
  const trim = team === 'blue' ? 0x1d4ed8 : 0xb91c1c;
  const armorMat = new MeshStandardMaterial({ color: 0x334155, metalness: 0.5, roughness: 0.35 });
  const trimMat = new MeshStandardMaterial({ color: trim, roughness: 0.45 });
  const staffMat = new MeshStandardMaterial({ color: 0x92400e, roughness: 0.6 });

  const torso = new Mesh(new CylinderGeometry(0.7, 0.55, 2.1, 10), armorMat);
  torso.position.y = 1.95;
  group.add(torso);

  const head = new Mesh(new SphereGeometry(0.45, 12, 12), armorMat);
  head.position.y = 3.25;
  group.add(head);

  const mask = new Mesh(new BoxGeometry(0.55, 0.25, 0.15), trimMat);
  mask.position.set(0, 3.25, 0.4);
  group.add(mask);

  const staff = new Mesh(new CylinderGeometry(0.08, 0.08, 3.2, 8), staffMat);
  staff.position.set(0.85, 2.0, 0.2);
  group.add(staff);

  const tip = new Mesh(new SphereGeometry(0.22, 10, 10), trimMat);
  tip.position.set(0.85, 3.55, 0.2);
  group.add(tip);

  return group;
}
